import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import SignupSuccess from "@/pages/SignupSuccess";
import AuthCallback from "@/pages/AuthCallback";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Onboarding from "@/pages/Onboarding";
import DashboardLayout from "@/pages/DashboardLayout";
import Dashboard from "@/pages/dashboard/Dashboard";
import CreativeMaker from "@/pages/dashboard/CreativeMaker";
import LeadGenerator from "@/pages/dashboard/LeadGenerator";
import Messages from "@/pages/dashboard/Messages";
import Plans from "@/pages/dashboard/Plans";
import Settings from "@/pages/dashboard/Settings";
import Admin from "@/pages/dashboard/Admin";
import Privacy from "@/pages/legal/Privacy";
import Terms from "@/pages/legal/Terms";
import { AuthProvider } from "@/lib/auth";
import { Toaster } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
// Synchronous Google OAuth callback detection — runs BEFORE normal routing
// so the session_id exchange happens first and ProtectedRoute doesn't 401.
function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/signup/success" element={<SignupSuccess />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/onboarding" element={<Onboarding />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/dashboard" element={<DashboardLayout />}>
        <Route index element={<Navigate to="profile" replace />} />
        <Route path="profile" element={<Dashboard />} />
        <Route path="creative" element={<CreativeMaker />} />
        <Route path="leads" element={<LeadGenerator />} />
        <Route path="messages" element={<Messages />} />
        <Route path="plans" element={<Plans />} />
        <Route path="settings" element={<Settings />} />
        <Route path="admin" element={<Admin />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
        </BrowserRouter>
        <Toaster richColors position="top-right" closeButton />
      </AuthProvider>
    </div>
  );
}

export default App;
